<template>
  <div class="list-skin-checkup-product">
    <b-table
      class="table table-responsive table-bordered w-50 product-table"
      hover
      responsive
      :fields="fields"
      :items="items"
    >
      <template #cell(action)="data">
        <button
          v-if="data.item.isDelete"
          class="btn btn-outline-danger btn-del ml-5"
          @click="deleteItems(data.index)"
        >
          Delete
        </button>
      </template>
    </b-table>
  </div>
</template>

<script>
import fields from "./SelectComponent/fieldsSkinCheckupProducts.json";
export default {
  props: {
    items: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      fields,
    };
  },
  methods: {
    deleteItems(index) {
      this.$emit("deleteSkinCheckupProduct", index);
    },
  },
};
</script>

<style lang="scss" scoped>
.product-table {
  margin-top: 0;
}
</style>
